/// <reference types="@helsenorge/framework-utils/types/hn"/>
import { decapitalize } from '@helsenorge/core-utils/string-utils';
import { error } from '@helsenorge/framework-utils/logger';
export function currentConfiguration() {
    return (window.HN?.Page ?? {});
}
export function resolve(originalKey, resources) {
    const key = decapitalize(originalKey);
    if (Object.prototype.hasOwnProperty.call(resources, key)) {
        return resources[key];
    }
    error(`The key ${key} is missing in HNTjenesterContent`);
    return undefined;
}
export function getCurrentConfiguration() {
    return (window.HN?.Page ?? {});
}
export function getService(resources) {
    const configuration = getCurrentConfiguration();
    if (resources && configuration && configuration.Tjenestemeny) {
        return resolve(configuration.Tjenestemeny, resources);
    }
    return undefined;
}
export function getRedirectToUrlAfterLogin() {
    const configuration = getCurrentConfiguration();
    if (configuration && configuration.RedirectToUrlAfterLogin) {
        return configuration.RedirectToUrlAfterLogin;
    }
    return;
}
export function getDelAvForeldresamtykke() {
    const configuration = getCurrentConfiguration();
    if (configuration && configuration.DelAvForeldresamtykke) {
        return configuration.DelAvForeldresamtykke;
    }
    return undefined;
}
